import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Leaf, BadgeDollarSign } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PatternLayer, patternFor } from "./patterns";

export const LabGrownPromo = () => {
  return (
    <section
      data-testid="lab-grown-promo"
      className="relative overflow-hidden bg-[#0D0D0D] py-20 lg:py-28 border-y border-[#C9A227]/25"
    >
      <PatternLayer pattern={patternFor("footer")} />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="inline-block text-[11px] uppercase tracking-[0.25em] text-[#E8CC6E] font-semibold border border-[#C9A227]/40 rounded-full px-4 py-1.5">
              Now in stock
            </span>
            <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-white mt-6" data-testid="lab-grown-heading">
              Lab-grown diamonds. <span className="text-[#E8CC6E]">Real diamonds.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-neutral-300 max-w-xl">
              Identical in chemistry, fire and brilliance to mined stones — real diamonds,
              graded on the same 4Cs, at a fraction of the price. Thousands of styles, shipped insured
              to your door.
            </p>
            <div className="mt-8 grid sm:grid-cols-3 gap-5 max-w-xl">
              {[
                { icon: BadgeCheck, text: "Certified & graded like mined diamonds" },
                { icon: BadgeDollarSign, text: "Up to 60% less than mined equivalents" },
                { icon: Leaf, text: "Grown above ground, conflict-free by origin" },
              ].map(({ icon: Icon, text }, i) => (
                <div key={i} className="flex items-start gap-3" data-testid={`lab-grown-point-${i}`}>
                  <Icon size={18} strokeWidth={1.5} className="text-[#E8CC6E] mt-0.5 shrink-0" />
                  <p className="text-xs leading-relaxed text-neutral-300">{text}</p>
                </div>
              ))}
            </div>
            <Link
              to="/collections/lab-grown-diamonds"
              data-testid="lab-grown-cta"
              className="mt-10 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#E8CC6E] to-[#C9A227] text-neutral-900 text-sm font-semibold px-8 py-3.5 hover:from-[#F0D988] hover:to-[#D4AF37] hover:-translate-y-0.5 transition-[transform] duration-300 shadow-[0_20px_40px_rgb(201,162,39,0.25)]"
            >
              Shop lab-grown diamonds <ArrowRight size={16} strokeWidth={1.5} />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-6 rounded-full bg-[radial-gradient(circle,rgba(232,204,110,0.18),transparent_65%)]" />
            <img
              src="/assets/lab-grown-diamonds.jpg"
              alt="Lab-grown diamond rings and loose certified diamonds on ivory silk"
              data-testid="lab-grown-image"
              className="relative w-full h-[320px] lg:h-[400px] object-cover rounded-sm border border-[#C9A227]/30 shadow-[0_30px_60px_rgba(0,0,0,0.5)]"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
